import ITimerState from "./state";

const isTimerRunning = (state:ITimerState) => state.isRunning

export default {
    isTimerRunning
}



// WEBPACK FOOTER //
// ./src/redux/modules/timer/selectors.ts